<template>
  <el-select
    v-model="study_id"
    class="studySelect"
    :placeholder="placeholder"
  >
    <el-option
      v-for="study in studies"
      :key="study.id"
      :label="study.title"
      :value="study.id"
    >
      {{ study.title }}
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "StudySelect",
  props: {
    value: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: () => ({
    local_value: null,
    studies: []
  }),
  computed: {
    study_id: {
      get() {
        return this.value || this.local_value
      },
      set(val) {
        this.local_value = val
        this.$emit('input', this.local_value)
      }
    }
  },
  async mounted() {
    // call api with no pagination
    this.studies = await this.$api.forms.getStudies()
  }
}
</script>

<style lang="scss" scoped>
$c: ".studySelect";

#{$c} {
}
</style>